'use client'

import { motion, useInView } from 'motion/react'
import React, {useRef, useState} from 'react'

import newsBgPic from "@assets/images/news-bg.png";
import starPic from "@assets/images/star.png";
import tabletPic from "@assets/images/tablet.jpg";
import axios from "axios";
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";

export default function Blog() {

  // const gotoPolarisInvest = ()=>{
  //   window.open('https://invest.polarisagi.com/', '_blank');
  // }

  const startStyle = {opacity: 0}
  const endStyle = {
    opacity: 1,
    ease: 'easeInOut',
  }
  const animationTransition = {
    duration: 2
  }

  const ref12 = useRef(null);
  const isRef12InView = useInView(ref12, {once: true})
  const ref13 = useRef(null);
  const isRef13InView = useInView(ref13, {once: true})
  const ref14 = useRef(null);
  const isRef14InView = useInView(ref14, {once: true})

  const [isSubscribing, setIsSubscribing] = useState(false);
  const [isBlur, setIsBlur] = React.useState(true);

  const submitForm = (e)=>{
    setIsBlur(false)
    const form = document.getElementById('emailForm1') as HTMLFormElement
    if (!form.checkValidity()) {
      form.reportValidity();
      setTimeout(() => {
        setIsBlur(true)
      }, 100)
    } else {
      subscribe()
    }
  }
  const subscribe = async ()=>{
    const emailInput = document.getElementById('emailInput1') as HTMLInputElement;
    const email = emailInput.value.trim();
    setIsSubscribing(true)
    const response = await axios.post(`${import.meta.env.VITE_APP_API_BASE_URL}/polaris-api/subscribe?email=${encodeURIComponent(email)}`);
    setIsSubscribing(false)

    if (response.data) {
      const { result } = response.data;
      if(result) {
        toast.success('Subscribe successfully.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        emailInput.value=''
      }
    }
  }

  return (
      <div className="mt-[66px]">
        <motion.section
          ref={ref12}
          initial={startStyle}
          animate={isRef12InView ? endStyle : {}}
          transition={animationTransition}
          className="w-[1360px] h-[653px] px-14 py-10 bg-gradient-to-b from-[#6E66E1] via-[#8B7CF4]/80 to-[#B2D2EA]/0 inline-flex flex-col justify-center items-center gap-2.5"
        >
          <div className="mx-auto">
            <div className="w-[1326px] py-5 flex flex-col justify-center items-center gap-24">
              <div className="w-[773px] flex flex-col justify-center items-center gap-6">
                <div className="w-8 h-9">
                  <img
                    src={starPic}
                    alt="Star"
                    className="object-cover"
                  />
                </div>
                <div
                  className="self-stretch text-center justify-start text-white text-7xl font-medium font-['Figtree'] leading-[76px]">Explore
                  Polaris <br/>Invest Insights
                </div>
                <div
                  className="w-[668px] text-center justify-start text-white text-xl font-normal font-['Inter'] leading-normal">Learn
                  how investing in unicorns can provide liquidity, portfolio flexibility, and access to the Top 20 most
                  valuable companies before their IPO. Sign up to receive an exclusive white paper on the VC and pre-IPO
                  secondaries Polaris.
                </div>
                <div className="self-stretch py-5 bg-stone-50 rounded-xl outline outline-1 outline-offset-[-1px] flex flex-col justify-center items-center gap-2.5">
                  <div className="self-stretch inline-flex justify-center items-center gap-2.5">
                    <form id="emailForm1" onSubmit={(e)=>{e.preventDefault();}} className="inline-flex flex-row justify-center items-center gap-2.5">
                      <input
                        id="emailInput1"
                        type="email"
                        placeholder="Email"
                        className={`w-80 flex-1 px-5 h-11 text-[14px] text-[#99ABB6] rounded-full bg-white border border-gray-200 focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${isSubscribing?'cursor-not-allowed':''}`}
                        required
                        disabled={isSubscribing}
                        onKeyDown={(e) => {
                          setIsBlur(false);
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            const input = e.target as HTMLInputElement;
                            input.setCustomValidity('');
                            if (!input.checkValidity()) {
                              input.setCustomValidity('');
                            }
                            input.reportValidity();
                          } else {
                            const input = e.target as HTMLInputElement;
                            // 将验证信息设置为多个空格，可让验证信息不显示
                            input.setCustomValidity('  ');
                          }
                        }}
                        onBlur={(e)=>{
                          const input = e.target as HTMLInputElement;
                          if(!isBlur){
                            setIsBlur(true);
                            if (!input.checkValidity()) {
                              input.setCustomValidity('');
                            }
                          }
                        }}
                      />
                    </form>
                    <button disabled={isSubscribing} onClick={submitForm} type="submit" className={`w-40 h-11 rounded-full bg-[#6E66E1] text-white text-[14px] font-medium hover:bg-[#5c4fd6] transition-colors inline-flex items-center justify-center ${isSubscribing?'cursor-not-allowed':'cursor-pointer'}`}>
                      Subscribe <svg className="w-4 h-4 ml-1 text-white transform rotate" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </button>
                  </div>
                  <div className="self-stretch inline-flex justify-center items-center gap-3.5">
                    <div className="w-[549px] justify-start">
                      <span className="text-stone-500 text-xs font-normal font-['Inter'] leading-3">We're committed to your privacy. POLARIS uses the information you provide to us to contact you about our relevant content, products, and services. You may unsubscribe from these communications at any time. For more information, check out our </span>
                      <span className="text-stone-500 text-xs font-normal font-['Inter'] underline leading-3 cursor-pointer"><Link to={`/privacy-policy`} target={`_blank`}>Privacy Policy</Link></span>
                      <span className="text-stone-500 text-xs font-normal font-['Inter'] leading-3">.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>

        <motion.section
          ref={ref13}
          initial={startStyle}
          animate={isRef13InView?endStyle:{}}
          transition={animationTransition}
          className="my-20 flex flex-row justify-center rounded-[10px]"
          style={{backgroundImage:`url(${tabletPic})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat'}}
        >
          <div className="mx-auto">
            <div className="w-[1360px] h-[680px] px-10 py-16 bg-gradient-to-b via-[#000000]/30 from-black/0 to-[#6E66E1] rounded-[10px] inline-flex flex-col justify-end items-start gap-2.5">
              <div className="flex flex-col justify-start items-start gap-4">
                <div className="inline-flex justify-start items-start gap-2.5">
                  <div className="h-9 px-5 rounded-[100px] outline outline-1 outline-white backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5 cursor-pointer">
                    <div className="justify-start text-white text-base font-medium font-['Figtree']">Events</div>
                  </div>
                  <div className="h-9 px-5 rounded-[100px] outline outline-1 outline-white backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5 cursor-pointer">
                    <div className="justify-start text-white text-base font-medium font-['Figtree']">Polaris Trends</div>
                  </div>
                </div>
                <div className="w-[945px] justify-start text-white text-7xl font-medium font-['Figtree'] leading-[83.60px]"><Link to={`/blog/1`}>The Basics about Cryptocurrency</Link></div>
                <div className="justify-center text-white text-lg font-normal font-['Figtree'] leading-loose">Lorem ipsum dolor sit ametero irseo, consectetur adipiscing elit. Scelerisque viverra donec diammeo.</div>
              </div>
            </div>
          </div>
        </motion.section>

        <motion.section ref={ref14} initial={startStyle} animate={isRef14InView?endStyle:{}} transition={animationTransition} className="pb-14 bg-white">
          <div className="mx-auto">
            <div className="w-[1260px] inline-flex justify-start items-center gap-14">
              <div className="flex justify-start items-center gap-5">
                <div className="h-9 px-5 bg-indigo-500 rounded-[100px] outline outline-1 outline-indigo-500 backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5 cursor-pointer">
                  <div className="justify-start text-white text-base font-bold font-['Figtree']">All</div>
                </div>
                <div className="h-9 px-5 rounded-[100px] outline outline-1 outline-indigo-500 backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5 cursor-pointer">
                  <div className="justify-start text-indigo-500 text-base font-medium font-['Figtree']">Polaris Trends</div>
                </div>
                <div className="h-9 px-5 rounded-[100px] outline outline-1 outline-indigo-500 backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5 cursor-pointer">
                  <div className="justify-start text-indigo-500 text-base font-medium font-['Figtree']">Insights</div>
                </div>
                <div className="h-9 px-5 rounded-[100px] outline outline-1 outline-indigo-500 backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5 cursor-pointer">
                  <div className="justify-start text-indigo-500 text-base font-medium font-['Figtree']">Events</div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
              <div className="w-full bg-white overflow-hidden flex flex-col">
                <div className="relative h-[233px]">
                  <img
                    src={newsBgPic}
                    alt=""
                    style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                  />
                  <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                    <div className="left-[12px] bottom-[0px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                      <div className="flex flex-col justify-start items-start gap-[0px]">
                        <div className="w-32 justify-start text-white text-2xl font-normal font-['Instrument_Serif'] capitalize leading-normal">HaoJun Jia</div>
                        <div className="justify-start text-white text-sm font-normal font-['Figtree']">Founder, Deep Principle</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    AI Investment Paradigm: What Are the Traits of the Next Generation of Great AI Companies?
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white overflow-hidden flex flex-col">
                <div className="relative h-[233px]">
                  <img
                    src={newsBgPic}
                    alt=""
                    style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                  />
                  <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                    <div className="left-[12px] bottom-[0px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                      <div className="flex flex-col justify-start items-start gap-[0px]">
                        <div className="w-32 justify-start text-white text-2xl font-normal font-['Instrument_Serif'] capitalize leading-normal">Zhijin Xia</div>
                        <div className="justify-start text-white text-sm font-normal font-['Figtree']">Managing Partner, Vertex Ventures</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    China’s Opportunity in AI for Science
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white overflow-hidden flex flex-col">
                <div className="relative h-[233px]">
                  <img
                    src={newsBgPic}
                    alt=""
                    style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                  />
                  <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                    <div className="left-[12px] bottom-[0px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                      <div className="flex flex-col justify-start items-start gap-[0px]">
                        <div className="w-32 justify-start text-white text-2xl font-normal font-['Instrument_Serif'] capitalize leading-normal">Grant Hosking</div>
                        <div className="justify-start text-white text-sm font-normal font-['Figtree']">Managing Partner, Align Ventures; Figure AI Board Member</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-6 text-left flex flex-col flex-1">
                  <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    Humanoid Robots Will Ultimately Become a Trillion-Dollar Industry; Brett May Become the Next Musk
                  </h3>
                  <div className="flex item-center font-medium mt-auto">
                    <a href="#" className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out">
                      Read More <svg className="w-4 h-4 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.section>
      </div>
  );
}
